import * as types from '../constants/actionTypes'

export const receiveShopifyPlans = (plans) => (
  {
    type: types.RECEIVE_SHOPIFY_PLANS,
    plans
  }
)



// WEBPACK FOOTER //
// ./src/actions/shopifyPlansAC.js